import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { apiService } from '../../../../../services/apiService';
function AssignmentsGeneralCase() {
    const location = useLocation();
    const parts_location = location.pathname.split("/");
    const taskId = parts_location[3] || null;
    const [showsave, setShowsave] = useState(true);
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [groupId, setGroupId] = useState([]);
    const [userId, setUserId] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const Role_user = localStorage.getItem('role');
    const [showgroupselect,setShowgroupselect] = useState(false);
    const [showSubmits, setShowSubmits] = useState(false);
    const [formData, setFormData] = useState({
        task_id : taskId,
        assignment_group_id: '',
        assigned_user_id: '',
        reason: '',
    });
    useEffect(()=> {
        if(Role_user === "admin" && showsave === true ){
            setShowgroupselect(true);
        }else if(Role_user === "admin" && showsave === false){
            setShowgroupselect(false);
        }
    },[Role_user,showsave]);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await apiService.getRequest(`task/details/${taskId}`);
                if (response.success && response.success === true) {
                    setShowSubmits(response.data.can_submit);
                    const refetchedData = response.data;
                    setFormData({
                        task_id: taskId,
                        assignment_group_id: refetchedData.assignment_group_id,
                        assigned_user_id: refetchedData.assigned_user_id,
                    });
                    if (!["in-progress", "pending"].includes(refetchedData.status_string)) {
                        setShowsave(false);
                    } else {
                        setShowsave(true);
                    }
                    if (refetchedData.assignment_group_id) {
                        const selectedGroupId = groupId.find(
                            (groupId) => groupId.id === refetchedData.assignment_group_id
                        );
                        if (selectedGroupId) {
                            setSelectedGroupId({
                                label: selectedGroupId.display_name,
                                value: selectedGroupId.id,
                            });
                        }

                        if (refetchedData.assigned_user_id) {
                            const responseAssignRoleId = await apiService.getRequest(`admin/roles-with-users?assignment_for=general_case&role_id=${refetchedData.assignment_group_id}`);
                            if (responseAssignRoleId.success) {
                                setUserId(responseAssignRoleId.data || []);
                                setTimeout(() => {
                                    const selectedUserId = responseAssignRoleId.data.find(
                                        (selectedUserId) =>
                                            selectedUserId.id === refetchedData.assigned_user_id
                                    );
                                    if (selectedUserId) {
                                        setSelectedUserId({
                                            label: selectedUserId.name,
                                            value: selectedUserId.id,
                                        });
                                    }
                                }, 0);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching onboarding data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [taskId, groupId]);
    

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.getRequest('admin/roles-with-users');
            if (response && response.success === true) {
                setGroupId(response.data);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        if (formData.assignment_group_id) {
            const fetchData = async () => {
                const response = await apiService.getRequest(`admin/roles-with-users?assignment_for=general_case&role_id=${formData.assignment_group_id}`);
                if (response && response.success === true) {
                    setUserId(response.data || []);
                }else{
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            };
            fetchData();
        }
    }, [formData.assignment_group_id]);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));

        setFormData({ ...formData, [name]: value });
    };
    const handleGroupChange = (selectedOption) => {
        setSelectedGroupId(selectedOption);
        const newGroupId = selectedOption ? selectedOption.value : '';
        setFormData((prev) => ({
            ...prev,
            assignment_group_id: newGroupId,
            assigned_user_id: ''
        }));
        setSelectedUserId(null);
    };

    const handleUserIdChange = (selectedOption) => {
        setSelectedUserId(selectedOption); // Update city
        handleInputChange({
            target: {
                name: 'assigned_user_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    const validateForm = () => {
        const newErrors = {};
        if (!formData.assignment_group_id) newErrors.assignment_group_id = "Assigned Group is required.";
        if (!formData.assigned_user_id) newErrors.assigned_user_id = "Assigned to is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };
    const [submitloader,setSubmitloader] = useState(false)
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloader(true);
        try {
    
            // Make the API request
            const response = await apiService.postRequest(`task/add/assignments`, formData);
    
            // Check response for success
            if (response && response.success === true) {
                setErrors({});
                setFormData({ ...formData, reason: '' });
                setErrorMessage('');
                toast(response.message || "Assigned Successfully");
            } else {
                setErrorMessage(response.message);
                if (response.errors) {
                    setErrors(response.errors);
                }
                if (response.notify_toast) {
                    setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    sessionStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.log(error,"Failed. Please try again");
        } finally {
            setSubmitloader(false); // Stop loader
        }
      };
  return (
    <>
        {loading ? 
        <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
            <img style={{ width: "100px" }} src={require('../../../../../assets/pinkloader.gif')} alt='Loading...' />
        </div> :<>
        <form className='w-100' 
            onSubmit={handleSubmit}
        >
                <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="darfts_inputs for_textarespec mt-4">
                    <Grid size={{sm:5.8, xs:12}} container flexDirection="column">
                        <span>Assignment Group<small>*</small></span>
                        <Select
                            isDisabled={!showgroupselect || !showSubmits}
                            className="basic-single select_withsearch"
                            classNamePrefix="select"
                            value={selectedGroupId}
                            defaultValue={null}
                            name="assignment_group_id"
                            options={groupId.map((state) => ({
                                label: state.display_name,
                                value: state.id,
                            }))}
                            onChange={handleGroupChange}
                        />
                        {errors.assignment_group_id && <p style={{color:"Red"}}>{errors.assignment_group_id}</p>}
                    </Grid>
                    <Grid size={{sm:5.8, xs:12}} container flexDirection="column">
                        <span>Assigned To<small>*</small></span>
                        <Select
                            isDisabled={!showsave || !showSubmits}
                            className="basic-single select_withsearch"
                            classNamePrefix="select"
                            value={selectedUserId}
                            defaultValue={null}
                            name="assigned_user_id"
                            options={userId.map((users) => ({
                                label: users.name,
                                value: users.id,
                            }))}
                            onChange={handleUserIdChange}
                        />
                        {errors.assigned_user_id && <p style={{color:"Red"}}>{errors.assigned_user_id}</p>}
                    </Grid>
                    <Grid size={{sm:12, xs:12}} container flexDirection="column">
                        <span>Reason for re-assignment</span>
                        <textarea disabled={!showsave || !showSubmits} placeholder='Write your reason' value={formData.reason} name='reason' onChange={handleInputChange} />
                        {errors.reason && <p style={{color:"Red"}}>{errors.reason}</p>}
                    </Grid>
                    {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                    {showsave && showSubmits &&
                    <Grid size={{sm:12, xs:12}} container justifyContent="space-between" className="mt-2">
                        <button type='submit' className='registersendbtn2'>{submitloader ? <img src={require('../../../../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                    </Grid>
                    }
                </Grid>
        </form>
        </>}
                
    </>
  )
}

export default AssignmentsGeneralCase
